// extracted by mini-css-extract-plugin
export default {"content":"searchInstaller_content__EaE-M","form":"searchInstaller_form__EvZKG"};